import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import { getSectionSubjects } from 'actions/subjects';
import { getUserAssessmentDates } from 'helpers/user';
import DateTime from '_class/DateTime';
import DatePickers from './Partials/DatePickers';
import UserSection from 'components/List/UserSection';
import UserSectionPreschool from 'components/List/UserSectionPreschool';
import { List, Spinner } from 'UI';
import { Button, getActiveLanguage, translate } from '@haldor/ui';
import User from '_class/User';

var TeacherSectionProgress = /*#__PURE__*/function (_Component) {
  _inherits(TeacherSectionProgress, _Component);

  var _super = _createSuper(TeacherSectionProgress);

  function TeacherSectionProgress(props) {
    var _this;

    _classCallCheck(this, TeacherSectionProgress);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.subjects == null) {
        _this.props.getSectionSubjects(_this.props.group.id, _this.state.currentStart, _this.state.currentEnd);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;

      if (start == "Invalid date") {
        start = Moment().subtract(1, "years");
      }

      if (end == "Invalid date") {
        end = Moment().add(1, "years");
      }

      localStorage.setItem('assessment-start-date', new DateTime(start).getDateStamp());
      localStorage.setItem('assessment-end-date', new DateTime(end).getDateStamp());

      _this.setState({
        start: new DateTime(start).getDateStamp(),
        end: new DateTime(end).getDateStamp()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateDates", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$state, start, end;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, start = _this$state.start, end = _this$state.end;

              _this.setState({
                loading: true,
                currentStart: start,
                currentEnd: end
              });

              _context.next = 4;
              return _this.props.getSectionSubjects(_this.props.group.id, start, end);

            case 4:
              _this.setState({
                loading: false
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderDateFilterText", function () {
      if (Moment().isSame(Moment(_this.state.currentEnd), 'day')) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }
      }, _this.props.translate('assessments-between'), " ", Moment(_this.state.currentStart).format('YYYY-MM-DD'), " ", _this.props.translate('to').toLowerCase(), " ", Moment(_this.state.currentEnd).format('YYYY-MM-DD'));
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: false,
      end: getUserAssessmentDates().end,
      start: getUserAssessmentDates().start,
      currentEnd: getUserAssessmentDates().end,
      currentStart: getUserAssessmentDates().start
    };
    return _this;
  }

  _createClass(TeacherSectionProgress, [{
    key: "render",
    value: function render() {
      var _this$props$group,
          _this$props$group$own,
          _this2 = this;

      var group = this.props.group;
      var loading = this.state.loading;
      var user = new User(this.props.currentUser);
      var isOwner = (_this$props$group = this.props.group) === null || _this$props$group === void 0 ? void 0 : (_this$props$group$own = _this$props$group.owners) === null || _this$props$group$own === void 0 ? void 0 : _this$props$group$own.find(function (owner) {
        return owner.userId == _this2.props.currentUser.id;
      });

      if ((user.isTeacher || user.isMentor) && isOwner || user.isAdministrator()) {
        return /*#__PURE__*/React.createElement("div", null, this.props.schoolType != 'PRESCHOOL' ? /*#__PURE__*/React.createElement("div", {
          className: "single-section",
          style: {
            marginBottom: '2em'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "form"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-row-half static datepickers"
        }, /*#__PURE__*/React.createElement(DatePickers, {
          onChange: this.onDateChange,
          startDate: this.state.start,
          endDate: this.state.end
        })))), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '1em'
          }
        }, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: this.updateDates
        }, this.props.translate('update')))) : null, this.renderDateFilterText(), loading ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : null, !loading && group != null ? this.props.schoolType == 'PRESCHOOL' ? /*#__PURE__*/React.createElement(List, {
          title: this.props.translate('students')
        }, /*#__PURE__*/React.createElement(UserSectionPreschool, {
          section: group,
          start: this.state.currentStart,
          end: this.state.currentEnd
        })) : /*#__PURE__*/React.createElement(UserSection, {
          section: group,
          start: this.state.currentStart,
          end: this.state.currentEnd,
          subjects: this.props.subjects
        }) : null);
      } else {
        return /*#__PURE__*/React.createElement("div", null);
      }
    }
  }]);

  return TeacherSectionProgress;
}(Component);

_defineProperty(TeacherSectionProgress, "defaultProps", {
  schoolType: 'COMPULSORY_SCHOOL'
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    group: state.sections.activeSection,
    currentUser: state.user.currentUser,
    subjects: state.Subjects.section
  };
}

export default connect(mapStateToProps, {
  getSectionSubjects: getSectionSubjects
})(TeacherSectionProgress);